import useApi from '../hook/useApi';

const useAdminsApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const getAdmins = async (page = 1, search = "") => {
    return sendRequest(`/imp/super_admin/get_all_imp_users?page=${page}&limit=10&search=${search}`, 'GET', {});
  };

  const addAdmin = async (payload) => {
    return sendRequest(`/imp/super_admin/add_imp_user`, 'POST', payload);
  };

  const updateAdmin = async (adminData) => {
    return sendRequest(`/imp/super_admin/edit_imp_user/${adminData.id}`, 'PUT', adminData);
  };

  const addRole = async (payload) => {
    return sendRequest(`/user/role_add`, 'POST', payload);
  };

  const getRoles = async (search = "", forDropDown = false) => {
    return sendRequest(`/user/role?forDropDown=${forDropDown}`, 'GET', {});
  };

  const getProfile = async () => {
    return sendRequest(`/imp/get_profile`, 'GET', {});
  }
  const updateProfile = async (adminData) => {
    return sendRequest(`/imp/update_profile`, 'PUT', adminData);
  };
  const updatePermissions = async (adminData) => {
    return sendRequest(`/imp/role_permissions/edit`, 'PUT', adminData);
  };
  const logoutUserBySuperAdmin = async (adminId) => {
    return sendRequest(`/imp/user_screen/logout_user_by_superadmin/${adminId}`, 'POST', {});
  };
  
  const getAdminWiseCalculatedInfo = async (filter, time_filter = 'daily', start_date = '', end_date = '') => {
    const params = new URLSearchParams({ filter, time_filter });
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    return sendRequest(`/imp/admin_wise_get_calculatedinfo?${params.toString()}`, 'GET', {});
  };
  
  return {
    getAdmins,
    addAdmin,
    updateAdmin,
    addRole,
    getRoles,
    getProfile,
    updateProfile,
    updatePermissions,
    logoutUserBySuperAdmin,
    getAdminWiseCalculatedInfo,
    loading,
    data,
    error,
  };
};

export default useAdminsApi;